module.exports = __webpack_public_path__ + "img/+90.54afa252.jpeg";